export default __webpack_public_path__ + "static/vs-code-screenshot-f58ad8246f22bf8f50c26b96310cb457.png";